// Autogenerated file
export const counterpartyFlagsEnum = {
    HasAccessToBids: "HasAccessToBids",
};
export const counterpartyFlags = [
    { label: "Предоставлен доступ к заявкам", value: "HasAccessToBids", intValue: 1 },
];
